import { RequestTypes } from '../../../hooks'

export const USER_API_PREFIX = '/api/users/v1/'
export const USER_FIND = '/find-for-green-cert-repayment'

export const getFindUsers = {
    link: `${USER_API_PREFIX}${USER_FIND}`,
    method: RequestTypes.post,
}
